import { createSlice } from "@reduxjs/toolkit";
import {
  addAppointment,
  deleteAppointment,
  fetchAppointments,
  updateAppointment,
} from "../actions/appointments";

const appointmentsSlice = createSlice({
  name: "appointments",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppointments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAppointments.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAppointments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addAppointment.fulfilled, (state, action) => {
        state.data.push({
          ...action.payload.newAppointment,
          id: action.payload.appointmentId,
        });
      })
      .addCase(updateAppointment.fulfilled, (state, action) => {
        state.data = state.data.map((item) =>
          item.id === action.payload.id
            ? { ...item, ...action.payload.updatedData }
            : item
        );
      })
      .addCase(deleteAppointment.fulfilled, (state, action) => {
        state.data = state.data.filter((item) => item.id !== action.payload.id);
      });
  },
});

export default appointmentsSlice.reducer;
